<template>
  <div
    class="compreSportsMeet_selectThemeContainer"
    :class="viewType"
    :style="{
      '--mixtmt_mixvw': cssDynamicObj.mixvw,
    }"
    v-if="currThemeObj"
  >
    <div class="themeItem_head" v-if="themeItem">
      <span class="head_selectArea">
        <span
          class="theme_select"
          v-for="selectItem in themeItem.filter.filterTypes"
          :key="selectItem.name"
        >
          <el-select
            v-show="selectItem.values && selectItem.values.length > 0"
            v-model="themeItem.actJson[selectItem.name]"
            placeholder="请选择"
            popper-class="theme_select_popper"
            :multiple="selectItem.isMultiple"
            :collapse-tags="selectItem.isMultiple"
            :popper-append-to-body="false"
            :filterable="selectItem.isMultiple ? false : selectItem.vagueSelect"
            @change="
              updateElOption(
                themeItem.analysisItemId,
                selectItem,
                themeItem.filter.filterTypes,
                themeItem.actJson
              )
            "
          >
            <el-option
              v-for="item in selectItem.values"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="selectItem.isMultiple && item.disabled ? true : false"
            ></el-option>
          </el-select>
        </span>
      </span>
      <span
        v-if="viewType !== 'poster'"
        class="publishBtn"
        @click="clickPublicTheme(themeItem)"
      >
        <svg
          t="1692698307306"
          class="publishBtn_icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="9670"
          width="50%"
          height="50%"
        >
          <path
            d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
            p-id="9671"
          ></path>
        </svg>
      </span>
    </div>
    <compreSportsMeet_themeItem
      :currThemeObj="currThemeObj"
      :themeItem="themeItem"
      :width100ThemeGraphicsIds="width100ThemeGraphicsIds"
      :width100ThemeGraphicsIdsClassName="width100ThemeGraphicsIdsClassName"
      :cssDynamicObj="cssDynamicObj"
      @inFilterChangeEvent="inFilterChangeEventHandler"
      v-if="themeItem.renderData && cssDynamicObj"
    ></compreSportsMeet_themeItem>
  </div>
</template>

<script>
import compreSportsMeet_themeItem from '@components/platfromBase/compreSportsMeet/themeItem.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'compreSportsMeet_selectThemeContainer',
  mixins: [cup_base_data_mixin],
  components: {
    compreSportsMeet_themeItem,
  },
  props: {
    themeItem: {
      type: Object,
      default: null,
    },
    width100ThemeGraphicsIds: {
      type: Array,
      default: () => {
        return []
      },
    },
    width100ThemeGraphicsIdsClassName: {
      type: Array,
      default: () => {
        return []
      },
    },
    viewType: {
      type: String,
      default: '', //区分在哪个页面使用，默认是赛果等带分享按钮的；['poster':放到【数据海报-编辑工作站】中使用，不要分享按钮]
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  data() {
    return {
      // tabNavArr: [
      //   {
      //     name: '阵容',
      //     act: true,
      //     id: 'lineup',
      //     className: 'left',
      //     isClickFlag: true,
      //   },
      //   {
      //     name: '球队数据',
      //     act: false,
      //     id: 'teamData',
      //     className: 'mid',
      //     isClickFlag: false,
      //   },
      //   {
      //     name: '球员数据',
      //     act: false,
      //     id: 'playerData',
      //     className: 'right',
      //     isClickFlag: true,
      //   },
      // ],
      // actTabNavObj: {},
    }
  },
  created() {
    // this.actTabNavObj.id = 'lineup'
    // console.log(this.tabNavArr, actTab);
    // this.tabNavBtnHandle(this.actTabNavObj)
  },
  methods: {
    // tabNavBtnHandle(actItem) {
    //   this.tabNavArr.forEach((item) => {
    //     if (item.id === actItem.id) {
    //       item.act = true
    //       this.actTabNavObj = item
    //     } else {
    //       item.act = false
    //     }
    //   })
    // },
    clickPublicTheme(themeItem) {
      // 分享主题，唤起容器分享监听事件
      console.debug('themeItem:', themeItem)
      // const query = this.$route.query
      themeItem.phaseId = themeItem.phaseId ? themeItem.phaseId : 0
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: themeItem,
        mid: themeItem.matchId ? themeItem.matchId : 0,
      })
    },
    async updateElOption(
      analysisItemId,
      curSelectItem,
      filterTypes,
      actAllSelectObj
    ) {
      console.debug(analysisItemId, curSelectItem, filterTypes, actAllSelectObj)
      this.$emit('changeSelectToThemeItemEvent', {
        analysisItemId,
        curSelectItem,
        filterTypes,
        actAllSelectObj,
      })
    },
    async inFilterChangeEventHandler(childData) {
      this.$emit('inFilterChangeEvent', childData)
    },
  },
}
</script>

<style lang="scss" scoped>
.compreSportsMeet_selectThemeContainer {
  --outsideRadiusSize: 0.694vw;
  --insideRadiusSize: 0.533vw;
  --insidePadSize: 0.32vw;
  position: relative;
  width: 100%;
  /* height: calc(29.162vw + var(--insidePadSize)); */
  height: auto;
  border: 1px solid var(--mixtmt_greyColor7);
  border-radius: var(--outsideRadiusSize);
  transition: all 0.3s linear;
  /* overflow: hidden; */
  &.poster {
    .themeItem_head {
      .head_selectArea {
        width: 100%;
      }
    }
  }
  .themeItem_head {
    width: 100%;
    height: calc(4vw * var(--mixtmt_mixvw));
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--mixtmt_greyColor12);
    border-radius: var(--outsideRadiusSize) var(--outsideRadiusSize) 0 0;
    .publishBtn {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: calc(3.2vw * var(--mixtmt_mixvw));
      font-weight: bold;
      svg.publishBtn_icon {
        fill: var(--mixtmt_greyColor4);
      }
    }
    .head_selectArea {
      width: calc(100% - 4.16vw * var(--mixtmt_mixvw));
      padding: 0 calc(0.694vw * var(--mixtmt_mixvw));
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .theme_select {
        /* width: 9.027vw; */
        /* width: 11.1vw; */
        width: auto;
        flex: 1;
        /* min-width: 11.1vw; */
        max-width: 50%;
        margin-right: calc(1.1vw * var(--mixtmt_mixvw));
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.mixtmt_pc {
  .compreSportsMeet_selectThemeContainer {
    &:hover {
      border: 1px solid var(--mixtmt_mainColor6);
      box-shadow: 0 calc(1px + 1px) calc(0.972vw * var(--mixtmt_mixvw)) 0
        var(--mixtmt_greyColor0);
    }
    .publishBtn {
      cursor: pointer;
      &:hover {
        svg.publishBtn_icon {
          fill: var(--mixtmt_subColor1_1);
        }
      }
    }
  }
}
</style>
<style lang="scss">
.compreSportsMeet_selectThemeContainer {
  .theme_select {
    .el-select {
      width: 100%;
      .el-input {
        font-size: calc(0.972vw * var(--mixtmt_mixvw));
        .el-input__inner {
          height: calc(2.083vw * var(--mixtmt_mixvw));
          padding: 0 calc(2.083vw * var(--mixtmt_mixvw)) 0
            calc(0.694vw * var(--mixtmt_mixvw));
          line-height: calc(2.083vw * var(--mixtmt_mixvw) - 2px);
          border-radius: calc(0.278vw * var(--mixtmt_mixvw));
          &:focus,
          &:active {
            border-color: var(--mixtmt_mainColor8);
          }
        }
        .el-select__caret {
          font-size: calc(0.972vw * var(--mixtmt_mixvw));
        }
        .el-input__icon {
          width: calc(0.972vw * var(--mixtmt_mixvw));
          line-height: calc(2.083vw * var(--mixtmt_mixvw));
        }
      }
      .el-select__tags {
        width: 70% !important;
        max-width: 70% !important;
        & > span {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
        }
        .el-tag--small {
          height: calc(1.86vw * var(--mixtmt_mixvw) - 2px);
          padding: 0 calc(0.416vw * var(--mixtmt_mixvw));
          line-height: calc(1.388vw * var(--mixtmt_mixvw));
          &.el-tag {
            margin: calc(0.138vw * var(--mixtmt_mixvw)) 0
              calc(0.138vw * var(--mixtmt_mixvw))
              calc(0.35vw * var(--mixtmt_mixvw));
            font-size: calc(0.833vw * var(--mixtmt_mixvw));
            border-radius: calc(0.278vw * var(--mixtmt_mixvw));
          }
          .el-icon-close {
            height: calc(1.5vw * var(--mixtmt_mixvw));
            width: calc(1.5vw * var(--mixtmt_mixvw));
            font-size: calc(0.833vw * var(--mixtmt_mixvw));
            line-height: calc(1.5vw * var(--mixtmt_mixvw));
            right: calc(-0.3vw * var(--mixtmt_mixvw));
            background-color: var(--mixtmt_greyColor5);
            &:hover {
              background-color: var(--mixtmt_mainColor8);
            }
          }
        }
      }
      .el-icon-arrow-up::before {
        content: '\e79a';
      }
    }
    .el-select-dropdown__empty {
      padding: calc(1.11vw * var(--mixtmt_mixvw));
      font-size: calc(0.972vw * var(--mixtmt_mixvw));
    }
  }
}

.mixtmt_pc .theme_select {
  .el-select {
    &:hover {
      .el-input__inner,
      .el-icon-arrow-up::before {
        color: var(--mixtmt_mainColor8);
      }
      .el-input__inner {
        border-color: var(--mixtmt_mainColor8);
      }
    }
  }
}
.theme_select_popper {
  .el-select-dropdown__item {
    font-size: calc(0.972vw * var(--mixtmt_mixvw));
    padding: 0 calc(1.042vw * var(--mixtmt_mixvw));
    height: calc(2.778vw * var(--mixtmt_mixvw));
    line-height: calc(2.778vw * var(--mixtmt_mixvw));
  }
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover,
  .el-select-dropdown__item.selected {
    color: var(--mixtmt_subColor1_1);
    background-color: var(--mixtmt_subColor1_2);
  }
  &.el-popper[x-placement^='bottom'] .popper__arrow {
    top: calc(-0.8vw * var(--mixtmt_mixvw));
    margin-right: calc(0.4vw * var(--mixtmt_mixvw));
    border-top-width: 0;
    &::after {
      top: 1px;
      margin-left: calc(-0.8vw * var(--mixtmt_mixvw));
      border-top-width: 0;
    }
  }
  &.el-popper .popper__arrow {
    border-width: calc(0.8vw * var(--mixtmt_mixvw));
    -webkit-filter: drop-shadow(
      0 calc(0.26667vw * var(--mixtmt_mixvw)) calc(1.6vw * var(--mixtmt_mixvw))
        rgba(0, 0, 0, 0.03)
    );
    filter: drop-shadow(
      0 calc(0.26667vw * var(--mixtmt_mixvw)) calc(1.6vw * var(--mixtmt_mixvw))
        rgba(0, 0, 0, 0.03)
    );
    &::after {
      border-width: calc(0.8vw * var(--mixtmt_mixvw));
    }
  }
}
</style>
